import { GROUP_ORDER_FORMAT_REG_EXP, ORDER_REFERENCE, POSTCODE, POSTCODE_FORMAT_REG_EXP, SINGLE_ORDER_FORMAT_REG_EXP } from './constants';

class OrderTrackerService {
  public orderReference: string = '';

  public postcode: string = '';

  initData = (): void => {
    const { orderReference, postcode } = this.getUrlParams();

    this.orderReference = orderReference;
    this.postcode = postcode;
  };

  isPostcodeValid = (postcode: string): boolean => POSTCODE_FORMAT_REG_EXP.test(postcode);

  isOrderReferenceValid = (orderRef: string): boolean =>
    SINGLE_ORDER_FORMAT_REG_EXP.test(orderRef) || GROUP_ORDER_FORMAT_REG_EXP.test(orderRef);

  getUrlParams = (): Record<string, string> => {
    const url = new URL(window.location.href);
    const searchParamsFromStorage = localStorage.getItem('search_params');
    const searchParams = searchParamsFromStorage ? new URLSearchParams(searchParamsFromStorage) : url.searchParams;
    
    return {
      orderReference: searchParams.get(ORDER_REFERENCE)?.toUpperCase() || '',
      postcode: searchParams.get(POSTCODE)?.toUpperCase() || '',
    };
  };

  isTrackingDataValid = (): boolean =>
    this.isOrderReferenceValid(this.orderReference) && this.isPostcodeValid(this.postcode);
}

export const orderTrackerService = new OrderTrackerService();
